import _initializerDefineProperty from "@babel/runtime/helpers/initializerDefineProperty";
import _createClass from "@babel/runtime/helpers/createClass";
import _applyDecoratedDescriptor from "@babel/runtime/helpers/applyDecoratedDescriptor";
import _initializerWarningHelper from "@babel/runtime/helpers/initializerWarningHelper";
var _dec, _dec2, _class, _descriptor, _descriptor2, _descriptor3;
import _regeneratorRuntime from "@babel/runtime/regenerator";
import { action, observable, computed } from 'mobx';
import { computedFn } from 'mobx-utils';
import _get from 'lodash/get';
import _camelCase from 'lodash/camelCase';
import { API_STATE } from "../../constants/index.js";
import { CountryClient } from "../../clients/country.client.js";
import { mapInitialStateToStoreState, flow } from "../../utils/store.utils/index.js";
import { formatCountry } from "../../utils/country.utils/index.js";
/**
 * country store
 * todo: this store is old and missing some standards
 *  * it is not using a factory
 *  * most of the computed properties returning a raw country not a formatted one
 */
var CountryStore = (_dec = observable.shallow, _dec2 = action.bound, (_class = /*#__PURE__*/function () {
  /**
   * constructor
   * @param {Object} initialState
   */
  function CountryStore(initialState) {
    var _this = this;
    if (initialState === void 0) {
      initialState = {};
    }
    _initializerDefineProperty(this, "data", _descriptor, this);
    _initializerDefineProperty(this, "API_STATE", _descriptor2, this);
    /**
     * get country by code
     * @param {string} countryCode
     * @returns {object}
     */
    this.getCountryByCode = computedFn(function (countryCode) {
      return _get(_this.countryHashMap, countryCode);
    });
    /**
     * get country by label
     * @param {string} countryLabel
     * @returns {object}
     */
    this.getCountryByLabel = computedFn(function (countryLabel) {
      return _get(_this.countryHashMap, countryLabel);
    });
    /**
     * get country by dial code
     * @param {string} dialCode
     * @returns {object}
     */
    this.getCountryByDialCode = computedFn(function (dialCode) {
      return _get(_this.countryHashMap, dialCode);
    });
    /**
     * get country code by label
     * @param {string} countryLabel
     * @returns {string}
     */
    this.getCountryCodeByLabel = computedFn(function (countryLabel) {
      return _get(_this.getCountryByLabel(countryLabel), 'Code');
    });
    /**
     * get country label by code
     * @param {string} countryCode
     * @param {string} locale
     * @returns {string}
     */
    this.getCountryLabelByCode = computedFn(function (countryCode, locale) {
      var label = _get(_this.getCountryByCode(countryCode), "Label", []).filter(function (label) {
        return _camelCase(label.Locale) === _camelCase(locale);
      });
      return _get(label, '[0].Value', '');
    });
    /**
     * get dial code by country code
     * @param {string} countryCode
     * @returns {string} country dial code
     */
    this.getDialCodeByCountryCode = computedFn(function (countryCode) {
      return _get(_this.getCountryByCode(countryCode), 'DialCode');
    });
    /**
     * get country by dial code
     * @param {string} dialCode
     * @returns {object}
     */
    this.getCountryCodeByDialCode = computedFn(function (dialCode) {
      return _get(_this.countryHashMap, dialCode + ".Code");
    });
    /**
     * fetch countryList
     * @param {Function} errorHandler
     */
    _initializerDefineProperty(this, "fetch", _descriptor3, this);
    this.updateInitialState(initialState);
  }
  var _proto = CountryStore.prototype;
  /**
   * update initial state
   * @param {Object} initialState
   */
  _proto.updateInitialState = function updateInitialState(initialState) {
    mapInitialStateToStoreState(this, initialState);
  };
  /**
   * handle success
   * @param {Object} data
   */
  _proto.onSuccess = function onSuccess(data) {
    this.data = data;
    this.API_STATE = API_STATE.SUCCESS;
  }

  /**
   * handle error
   * @param {Object} error
   * @param {Function} errorHandler
   */;
  _proto.onError = function onError(error, errorHandler) {
    errorHandler(error);
    this.API_STATE = API_STATE.FAILED;
  };
  _createClass(CountryStore, [{
    key: "countryHashMap",
    get:
    /**
     * countryHashMap Transform API response from array to object
     * @returns {Object} countryList
     */
    function get() {
      return this.data.reduce(function (countryMap, country) {
        countryMap[_get(country, 'Code')] = country;
        countryMap[_get(country, 'Label[0].Value')] = country;
        countryMap[_get(country, 'Label[1].Value')] = country;
        countryMap[_get(country, 'DialCode')] = country;
        return countryMap;
      }, {});
    }

    /**
     * get country formatted list
     * @returns {{labelData: *, arLabel: string, code: *, dialCode: *, label: string}[]}
     */
  }, {
    key: "countryList",
    get: function get() {
      return this.data.map(function (country) {
        return formatCountry(country);
      });
    }
  }]);
  return CountryStore;
}(), (_descriptor = _applyDecoratedDescriptor(_class.prototype, "data", [_dec], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function initializer() {
    return [];
  }
}), _descriptor2 = _applyDecoratedDescriptor(_class.prototype, "API_STATE", [observable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function initializer() {
    return API_STATE.INITIAL;
  }
}), _applyDecoratedDescriptor(_class.prototype, "countryHashMap", [computed], Object.getOwnPropertyDescriptor(_class.prototype, "countryHashMap"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "countryList", [computed], Object.getOwnPropertyDescriptor(_class.prototype, "countryList"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "updateInitialState", [action], Object.getOwnPropertyDescriptor(_class.prototype, "updateInitialState"), _class.prototype), _descriptor3 = _applyDecoratedDescriptor(_class.prototype, "fetch", [_dec2], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function initializer() {
    return flow(function (errorHandler) {
      var _this2 = this;
      if (errorHandler === void 0) {
        errorHandler = function errorHandler() {
          return null;
        };
      }
      return /*#__PURE__*/_regeneratorRuntime.mark(function _callee() {
        var response;
        return _regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) switch (_context.prev = _context.next) {
            case 0:
              _this2.API_STATE = API_STATE.LOADING;
              _context.prev = 1;
              _context.next = 4;
              return CountryClient.getCountryList();
            case 4:
              response = _context.sent;
              _this2.onSuccess(response);
              _context.next = 11;
              break;
            case 8:
              _context.prev = 8;
              _context.t0 = _context["catch"](1);
              _this2.onError(_context.t0, errorHandler);
            case 11:
            case "end":
              return _context.stop();
          }
        }, _callee, null, [[1, 8]]);
      })();
    });
  }
}), _applyDecoratedDescriptor(_class.prototype, "onSuccess", [action], Object.getOwnPropertyDescriptor(_class.prototype, "onSuccess"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "onError", [action], Object.getOwnPropertyDescriptor(_class.prototype, "onError"), _class.prototype)), _class));
export { CountryStore as default };